// Pinia store module
// Generic data common to all Square Bell web apps

import { defineStore } from 'pinia'
import { ref, reactive, watch, computed } from 'vue'
import {debug} from '../lib/sb_utility.mjs'

import info from './sbapp-info.yaml'

const storagePrefix = "SB" + info.appIdNum + '.'

export const useSbappStore = defineStore('sbapp', ()=>{
   debug('Setup sbapp', 'sbapp')

   // App information
   const appname = ref(info.appName)
   const idStr = ref(info.appIdStr)
   const pid = ref(info.appIdNum)
   const longname = ref(info.appLongName ?? info.appName)
   const appVersionStr = ref(info.version)

   // Use of LocalStorage
   debug(localStorage.getItem(storagePrefix+"useLocal")=="yes", 'sbapp')
   const useLocal = ref(localStorage.getItem(storagePrefix+"useLocal")=="yes")
   watch(useLocal, (newval, _oldval)=>{
      if(newval) startUsingLocal()
      else stopUsingLocal()
   })
   const usingLocal = computed(()=>useLocal.value)
   function startUsingLocal(){
      debug("Start using LocalStorage", "sbapp")
      useLocal.value=true
      remember("useLocal", "yes")
   }
   function stopUsingLocal(){
      debug("Stop using LocalStorage", "sbapp")
      useLocal.value = false
      localStorage.clear()
   }
   function remember(key, valStr){
      debug(`Remember ${storagePrefix+key}=${valStr}`, 'sbapp')
      if(useLocal.value) localStorage.setItem(storagePrefix+key, valStr)
   }
   function recall(key){
      debug("Recall "+key, 'sbapp')
      if(useLocal.value) {
         let stored = localStorage.getItem(storagePrefix+key)
         debug("Recalling: "+stored, 'sbapp')
         return stored
      } else {
         return null
      }
   }

   // Entrypoint terms and status
   const terms = reactive([])
   info.conditions.forEach((item)=>{
      if(typeof item === 'string') {
         terms.push({ type: 'para', text: item })
      } else switch(item.type) {
         case 'accept':
         case 'head':
         case 'optionUseLocal':
            terms.push(item)
         // ignore any other types (until implemented)
      }
   })
   const useLocalTerm = computed(()=>terms.find(
      (t)=>t.type=='optionUseLocal'
   ))

   let storedApprovalVersion = localStorage.getItem(storagePrefix+'TermsOK')
   const enter = ref(storedApprovalVersion==info.version)
   const entryOk = computed(()=>enter.value)
   function approveEntry(_options){ 
      debug('Approve entry', 'sbapp')
      enter.value = true 
      remember('TermsOK', info.version)
   }

   // App save status
   const unsaved = reactive([])
   const readyToQuit = computed(()=>unsaved.length==0)
   async function modified(dataLabel){
      // Mark the app as having unsaved data by adding label to the list
      unsaved.push(dataLabel)
   }
   async function saved(dataLabel){
      // Mark the app as saved by removing label from the list
      let labelix = unsaved.indexOf(dataLabel)
      unsaved.splice(labelix, 1)
   }

   return {
      appname, idStr, pid, longname, appVersionStr,
      filedir: `app_${pid.value}_${idStr.value}`,

      useLocal, usingLocal, startUsingLocal, stopUsingLocal,
      remember, recall,

      terms, useLocalTerm,
      enter, entryOk, approveEntry,

      unsaved, readyToQuit, modified, saved,
   }
})
